
import { Vue } from "vue-class-component";

export default class ClaimPlus extends Vue {}
